import HelpVideo from "../../components/HelpVideo"
import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"
import Typography from "@material-ui/core/Typography"
import { useHelpVideo } from "../../hooks/use-help-video"
import { Link } from "react-router-dom"
import { useUrlWithContext } from "../../hooks/use-url-with-context"
import { paths } from "../../paths"
import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core"
import { useI18n } from "../../hooks"

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.palette.background.default,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
  },
  paper: {
    width: "100%",
    maxWidth: 650,
    padding: theme.spacing(4),
    marginTop: theme.spacing(8),
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(2),
      marginTop: theme.spacing(4),
    },
    boxSizing: "border-box",
  },
  videoSection: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(4),
    textAlign: "center",
  },
}))

const defaultTranslations = {
  pageTitle: "Welcome to Starbrix!",
  pageSubtitle: "Here's an introductory video to help you get started.",
  actionButton: "Ready to dive in? Go to your home page",
  errorLoadingVideo: "Error loading video.",
}

type Translations = typeof defaultTranslations

const useTranslations = (defaults = defaultTranslations): Translations => {
  const { translations: t = {} } = useI18n("member-welcome-page")

  function translate(key: keyof Translations) {
    return t[key] || defaults[key]
  }

  return {
    pageTitle: translate("pageTitle"),
    pageSubtitle: translate("pageSubtitle"),
    actionButton: translate("actionButton"),
    errorLoadingVideo: translate("errorLoadingVideo"),
  }
}

const MemberWelcomeRoute = () => {
  const { video, isLoading, isError } = useHelpVideo("collaboration")
  const { createPathWithContext } = useUrlWithContext()
  const memberHomePath = createPathWithContext(paths.home())
  const classes = useStyles()
  const translations = useTranslations(defaultTranslations)

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h4" gutterBottom>
          {translations.pageTitle}
        </Typography>
        <Typography variant="body1" gutterBottom color="textSecondary">
          {translations.pageSubtitle}
        </Typography>
        <div className={classes.videoSection}>
          {isLoading ? (
            <CircularProgress />
          ) : isError ? (
            <p>{translations.errorLoadingVideo}</p>
          ) : (
            <HelpVideo video={video} />
          )}
        </div>
      </Paper>
      <div className={classes.action}>
        <Button variant="outlined" component={Link} to={memberHomePath} color="primary">
          {translations.actionButton}
        </Button>
      </div>
    </div>
  )
}

export default MemberWelcomeRoute
